<script setup lang="ts">
  import { getRawInputElementCheckedValue, getRawInputElementValue, useMarketoInputProxy } from '../composables/use-marketo-input-proxy/index.js';
  import type { AnyMarketoInputName } from '../types/definitions/inputs/marketo-input-names-and-values.js';
  import { useVModel, refDefault } from '@vueuse/core';
  import { type Nil } from "@mcwd/typescript-type-guards";

  export interface MarketoInputSyncWrapperProps {
    marketoInputName: AnyMarketoInputName;
    modelValue: string | string[] | number | boolean | Nil;
    parseAsBoolean?: boolean | Nil;
  }
  const props = defineProps<MarketoInputSyncWrapperProps>();

  const emit = defineEmits<(e: 'update:modelValue', modelValue:  MarketoInputSyncWrapperProps["modelValue"]) => void>();

  const proxyModelValue = refDefault(useVModel(props, 'modelValue', emit), null);

  const getValue = props.parseAsBoolean ? getRawInputElementCheckedValue : getRawInputElementValue;
  useMarketoInputProxy({ inputName: props.marketoInputName, proxyInputValue: proxyModelValue, getValue, callerLabel: "marketo-input-sync" });
</script>

<template>
  <slot />
</template>